import { render, staticRenderFns } from "./faceTwo.vue?vue&type=template&id=2eb9cffe"
import script from "./faceTwo.vue?vue&type=script&lang=js"
export * from "./faceTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports